import * as Sentry from "@sentry/nuxt";
Sentry.init({
    // If set up, you can use your runtime config here
    // dsn: useRuntimeConfig().public.sentry.dsn,
    dsn: "https://b0a409fe643a2f0302e7f515804beef9@o4505913034014720.ingest.us.sentry.io/4508239449686016",
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.4,
});
